import { useQuery } from '@tanstack/react-query';
import { pollingQueryOptions } from '@/lib/query-polling';
import { useDataSources } from '@/services/datasources';
import type { Instrument, Reading } from '@/domain';

export interface MapaData {
  instruments: Instrument[];
  readings: Reading[];
  isLoading: boolean;
  error: Error | null;
}

/**
 * Dados brutos do M2 — instrumentos + leituras mais recentes.
 * Pins e grupos são derivados no componente (após o filtro da legenda),
 * por isso não são computados aqui.
 */
export function useMapaData(): MapaData {
  const { instrumentacao } = useDataSources();

  const { data: instruments = [], isLoading: loadingInst, error: errInst } = useQuery({
    queryKey: ['instruments'],
    queryFn: () => instrumentacao.listInstruments(),
    ...pollingQueryOptions,
  });

  // GUPM-136 — última leitura POR instrumento (não top-N global): o `valorAtual` da
  // tabela precisa da leitura atual de cada instrumento, senão os de baixa cadência
  // (crowded-out pelo TILT de 30min no top-N) apareciam sem valor.
  const { data: readings = [], isLoading: loadingRead, error: errRead } = useQuery({
    queryKey: ['readings', 'current'],
    queryFn: () => instrumentacao.listCurrentReadings(),
    ...pollingQueryOptions,
  });

  return {
    instruments,
    readings,
    isLoading: loadingInst || loadingRead,
    error: (errInst ?? errRead) as Error | null,
  };
}
